import React, { useState } from 'react';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AbstractExternalExam } from '../../../../../api/types/settings/studies/abstract-external-exam';
import dateUtils from '../../../../../utils/date-format';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { AddNewExternalExamDialog } from './components/add-new-external-exam-dialog';
import { deleteExternalExamOperation } from './operations/delete-external-exam-operation';
import { EditExternalExamDialog } from './components/edit-external-exam-dialog';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';

export const SettingsEducationExternalTabs = observer(() => {
  const [addNewExternalExam, setAddNewExternalExam] = useState(false);
  const [editExternalExam, setEditExternalExam] =
    useState<AbstractExternalExam | null>(null);
  const [selectedExternalExams, setSelectedExternalExams] = useState<
    AbstractExternalExam[]
  >([]);

  const [deleteExternalExamId, setDeleteExternalExamId] = useState<
    number | null
  >(null);

  const handleDeleteExternalExam = async (externalExamId: number) => {
    await deleteExternalExamOperation(externalExamId, setDeleteExternalExamId);
  };

  const handleEditExternalExam = (externalExam: AbstractExternalExam) => {
    setEditExternalExam(externalExam);
  };

  const getMajorName = (majorId: number): string => {
    const major = globalSettingsStores.majors.find((m) => m.id === majorId);
    return major ? major.majorName : '';
  };

  return (
    <div>
      <Dialog
        header="הוספת מבחן חיצוני"
        visible={addNewExternalExam}
        onHide={() => setAddNewExternalExam(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddNewExternalExamDialog onHide={() => setAddNewExternalExam(false)} />
      </Dialog>

      <EditExternalExamDialog
        externalExam={editExternalExam}
        onHide={() => setEditExternalExam(null)}
      />

      <Button
        onClick={() => setAddNewExternalExam(true)}
        style={{ height: '30px' }}
        label={'הוספה'}
      />
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedExternalExams}
        onSelectionChange={(e) => setSelectedExternalExams(e.value)}
        value={globalSettingsStores.externalExams}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="examName"
          header="שם המקצוע"
        />

        <Column style={{ textAlign: 'right' }} field="symbol" header="סמל" />

        <Column
          style={{ textAlign: 'right' }}
          header="מגמה"
          body={(rowData: AbstractExternalExam) => (
            <div>{getMajorName(rowData.majorId)}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          header="סמל מגמה"
          field={'majorSymbol'}
        />

        <Column
          style={{ textAlign: 'right' }}
          header="שירות תשלום"
          field={'paymentServiceName'}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          body={(rowData: AbstractExternalExam) => (
            <div>{dateUtils.displayFormatDate(rowData.createdAt)}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: AbstractExternalExam) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת מבחן חיצוני'}
                onClick={() => handleEditExternalExam(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת מבחן חיצוני'}
                loading={deleteExternalExamId === data.id}
                disabled={deleteExternalExamId !== null}
                onClick={() => handleDeleteExternalExam(data.id)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
